<template>
  <div class="animated fadeIn">
    <b-row class="pb-4">
      <b-col lg="12">
        <h2>
          Transactions for
          <span style="color: #ff8800;">{{
            product.product_edit.ProductName
          }}</span>
          <b-button
            variant="white active"
            class="myMediumButton m-0 p-0 pb-1 ml-2 "
            @click="DashRouteTo('/products/edit')"
          >
            <i style="color: #ff8800;" class="fa fa-lg fa-edit" />
          </b-button>
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="9">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newEntity"
          >
            <i class="fa fa-plus"></i>
            New Transaction
          </b-button>
        </div>
        <div>
          <InventoryTransactionDialog
            :myIteration="componentKey"
            @filterList="myLoadComponent"
          >
            <div slot="header">
              <!-- <h2>{{ mySelected.Quantity }}</h2> -->
            </div>
            <div slot="details">
              <!-- <div>{{ mySelected.Description }}</div> -->
            </div>
          </InventoryTransactionDialog>
        </div>
        <div>
          <StyledDialog
            @filterList="myLoadComponent"
            :CurrentObject="mySelected"
            EntityType="InventoryTransaction"
          >
            <div slot="header"></div>
            <div slot="details">
              <h2>Quantity: {{ mySelected.Quantity }}</h2>
              <div>Description: {{ mySelected.Description }}</div>
            </div>
            <span slot="entityType">Transaction</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
          <!-- <template slot="Balance" slot-scope="data">
            <b>{{ curTotal(data.item.Quantity) }}</b>
          </template> -->
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import InventoryTransactionDialog from "@/components/dialogs/InventoryTransactionModal.vue";

export default {
  name: "ProductTransactionList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "Description",
          label: "Description",
          sortable: true,
          thStyle: "width: 20%;"
        },
        {
          key: "Quantity",
          label: "Quantity",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "EnteredByName",
          label: "Entered By",
          sortable: true,
          thStyle: "width: 20%;"
        },
        {
          key: "DateTransaction",
          label: "Date",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "Balance",
          label: "Balance",
          sortable: false,
          thStyle: "width: 5%;"
        }

        // {
        //   key: "ProductShortDesc",
        //   label: "Description",
        //   sortable: true,
        //   thStyle: "width: 40%;"
        // }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      currentTotal: 0,
      is_valid_modal: false,
      componentKey: 0
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog,
    InventoryTransactionDialog
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.product.products.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["product", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    curTotal(val) {
      var _retObj = this.currentTotal + val;
      this.currentTotal = this.currentTotal + val;
      return _retObj;
    },
    async myLoadComponent() {
      await this.$store.dispatch(
        "product/fetchTransactions",
        this.$store.state.product.product_edit
      );
      this.filterList();
    },
    async myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      //console.log(record);
      // this.mySelected = record;
      // this.$bvModal.show("modal-2");
      await this.$store
        .dispatch("product/loadTransactionEdit", record.InventoryTransactionID)
        .then(() => {
          //alert(this.$store.state.product.transaction_edit.Quantity);
          //this.$router.push({ name: "Product" });
          this.$bvModal.show("modal-3");
        });
    },
    newEntity() {
      this.$store
        .dispatch("product/newTransaction", this.createFreshObject())
        .then(() => {
          //this.$router.push({ name: "Product" });
          this.$bvModal.show("modal-3");
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    async SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        InventoryTransactionID: -1,
        ProductID: this.$store.state.product.product_edit.ProductID,
        Quantity: "",
        Description: ""
      };
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.product.transactions.filter(
        transaction =>
          transaction.EnteredByName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          transaction.Description.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          transaction.DateTransaction.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    DashRouteTo(_page) {
      this.$router.push(_page);
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
